// import React from 'react';
// import { useForm } from 'react-hook-form';
// import { useMutation } from 'react-query';
// import { Box, Button, FormControl, FormLabel, Input, FormErrorMessage, useToast } from '@chakra-ui/react';
// import UserService from '../../services/UserService'; // Import your service

// const UserUpdateForm = ({ user, onClose }) => {
//   const { register, handleSubmit, formState: { errors } } = useForm({
//     defaultValues: {
//       name: user.name,
//       email: user.email,
//       phoneNumber: user.phoneNumber,
//       companyname: user.companyname,
//       address: user.address,
//       specialist: user.specialist,
//       birthdate: new Date(user.birthdate).toISOString().substring(0, 10),
//     }
//   });

//   const toast = useToast();
//   const mutation = useMutation(UserService.updateUser, {
//     onSuccess: () => {
//       toast({
//         title: "User updated successfully.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       onClose();
//     },
//     onError: (error) => {
//       const errorMessage = Array.isArray(error.response.data.errors)
//         ? error.response.data.errors.map(err => err.msg).join(', ')
//         : error.response.data.message;

//       toast({
//         title: "Error updating user.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const onSubmit = (data) => {
//     mutation.mutate({ userId: user._id, ...data });
//   };

//   return (
//     <Box>
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <FormControl isInvalid={errors.name}>
//           <FormLabel htmlFor="name">Name</FormLabel>
//           <Input id="name" {...register('name', { required: 'Name is required' })} />
//           <FormErrorMessage>{errors.name && errors.name.message}</FormErrorMessage>
//         </FormControl>

//         <FormControl isInvalid={errors.email}>
//           <FormLabel htmlFor="email">Email</FormLabel>
//           <Input id="email" {...register('email', { required: 'Email is required' })} />
//           <FormErrorMessage>{errors.email && errors.email.message}</FormErrorMessage>
//         </FormControl>

//         <FormControl isInvalid={errors.phoneNumber}>
//           <FormLabel htmlFor="phoneNumber">Phone Number</FormLabel>
//           <Input id="phoneNumber" {...register('phoneNumber', { required: 'Phone number is required' })} />
//           <FormErrorMessage>{errors.phoneNumber && errors.phoneNumber.message}</FormErrorMessage>
//         </FormControl>

//         <FormControl isInvalid={errors.companyname}>
//           <FormLabel htmlFor="companyname">Company Name</FormLabel>
//           <Input id="companyname" {...register('companyname')} />
//           <FormErrorMessage>{errors.companyname && errors.companyname.message}</FormErrorMessage>
//         </FormControl>

//         <FormControl isInvalid={errors.address}>
//           <FormLabel htmlFor="address">Address</FormLabel>
//           <Input id="address" {...register('address')} />
//           <FormErrorMessage>{errors.address && errors.address.message}</FormErrorMessage>
//         </FormControl>

//         <FormControl isInvalid={errors.specialist}>
//           <FormLabel htmlFor="specialist">Specialist</FormLabel>
//           <Input id="specialist" {...register('specialist')} />
//           <FormErrorMessage>{errors.specialist && errors.specialist.message}</FormErrorMessage>
//         </FormControl>

//         <FormControl isInvalid={errors.birthdate}>
//           <FormLabel htmlFor="birthdate">Birthdate</FormLabel>
//           <Input type="date" id="birthdate" {...register('birthdate', { required: 'Birthdate is required' })} />
//           <FormErrorMessage>{errors.birthdate && errors.birthdate.message}</FormErrorMessage>
//         </FormControl>

//         <Button mt={4} colorScheme="teal" isLoading={mutation.isLoading} type="submit">
//           Update
//         </Button>
//       </form>
//     </Box>
//   );
// };

// export default UserUpdateForm;
import React from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { Box, Button, FormControl, FormLabel, Input, FormErrorMessage, useToast } from '@chakra-ui/react';
import UserService from '../../services/UserService'; // Import your service

const UserUpdateForm = ({ user, onClose }) => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      name: user.name,
      email: user.email,
      phoneNumber: user.phoneNumber,
      companyname: user.companyname,
      address: user.address,
      specialist: user.specialist,
      birthdate: new Date(user.birthdate).toISOString().substring(0, 10),
    }
  });

  const toast = useToast();
  const mutation = useMutation(UserService.updateUser, {
    onSuccess: () => {
      toast({
        title: "User updated successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      onClose();
    },
    onError: (error) => {
      const errorMessage = Array.isArray(error.response.data.errors)
        ? error.response.data.errors.map(err => err.msg).join(', ')
        : error.response.data.message;

      toast({
        title: "Error updating user.",
        description: errorMessage,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  });

  const onSubmit = (data) => {
    const formData = new FormData();
    console.log(data)
    formData.append('name', data.name);
    formData.append('email', data.email);
    formData.append('phoneNumber', data.phoneNumber);
    formData.append('companyname', data.companyname);
    formData.append('address', data.address);
    formData.append('specialist', data.specialist);
    formData.append('birthdate', data.birthdate);

    if (data.idImage && data.idImage[0]) {
      formData.append('idImage', data.idImage[0]);
    }

    if (data.idbackImage && data.idbackImage[0]) {
      console.log(data.idbackImage[0])
      formData.append('idbackImage', data.idbackImage[0]);
    }

    mutation.mutate({ userId: user._id, formData });
  };

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl isInvalid={errors.name}>
          <FormLabel htmlFor="name">Name</FormLabel>
          <Input id="name" {...register('name', { required: 'Name is required' })} />
          <FormErrorMessage>{errors.name && errors.name.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.email}>
          <FormLabel htmlFor="email">Email</FormLabel>
          <Input id="email" {...register('email')} />
          <FormErrorMessage>{errors.email && errors.email.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.phoneNumber}>
          <FormLabel htmlFor="phoneNumber">Phone Number</FormLabel>
          <Input id="phoneNumber" {...register('phoneNumber', { required: 'Phone number is required' })} />
          <FormErrorMessage>{errors.phoneNumber && errors.phoneNumber.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.companyname}>
          <FormLabel htmlFor="companyname">Company Name</FormLabel>
          <Input id="companyname" {...register('companyname')} />
          <FormErrorMessage>{errors.companyname && errors.companyname.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.address}>
          <FormLabel htmlFor="address">Address</FormLabel>
          <Input id="address" {...register('address')} />
          <FormErrorMessage>{errors.address && errors.address.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.specialist}>
          <FormLabel htmlFor="specialist">Specialist</FormLabel>
          <Input id="specialist" {...register('specialist')} />
          <FormErrorMessage>{errors.specialist && errors.specialist.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.birthdate}>
          <FormLabel htmlFor="birthdate">Birthdate</FormLabel>
          <Input type="date" id="birthdate" {...register('birthdate', { required: 'Birthdate is required' })} />
          <FormErrorMessage>{errors.birthdate && errors.birthdate.message}</FormErrorMessage>
        </FormControl>

        <FormControl>
          <FormLabel htmlFor="idImage">ID Image</FormLabel>
          <Input type="file" id="idImage" {...register('idImage')} />
        </FormControl>

        <FormControl>
          <FormLabel htmlFor="idbackImage">ID Back Image</FormLabel>
          <Input type="file" id="idbackImage" {...register('idbackImage')} />
        </FormControl>

        <Button mt={4} colorScheme="teal" isLoading={mutation.isLoading} type="submit">
          Update
        </Button>
      </form>
    </Box>
  );
};

export default UserUpdateForm;
